module.exports = "<div>\n  <div class=\"ContentLoader\" ng-if=\"!ctrl.isErrorMessageVisible\">\n    <div class=\"Loader\"></div>\n  </div>\n  <sa-fetch-error-message ng-if=\"ctrl.isErrorMessageVisible\"></sa-fetch-error-message>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/modules/autologin/autologin.html
// module id = 516
// module chunks = 24